// extracted by mini-css-extract-plugin
export default {"nav":"CloseToolbar_nav__daP9R","box":"CloseToolbar_box__NsPni","title":"CloseToolbar_title__v2udr","close":"CloseToolbar_close__XRdO+"};